module.exports = "<p>solar works!</p>\n"